module.exports = __webpack_public_path__ + "img/MY.2bfb948a.svg";